import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';
import { initialMultiSelectState, MULTI_SELECT_NAME, type MultiSelectSlice, type MultiSelectState } from './slice';

export const getDomainState = (state: MultiSelectSlice): Record<string, MultiSelectState> => state[MULTI_SELECT_NAME];
export const getMultiSelectName = (state: unknown, { multiSelectName }: { multiSelectName: string }): string =>
  multiSelectName;

export const getMultiSelectState = createCachedSelector(
  getDomainState,
  getMultiSelectName,
  (state, multiSelectName) => state[multiSelectName] || initialMultiSelectState
)(getMultiSelectName);

export const getSelected = createSelector(getMultiSelectState, (state) => new Set(state.selected));

export const getSelectAll = createSelector(getMultiSelectState, (state) => state.selectAll);

export const getIds = createSelector(getMultiSelectState, (state) => state.ids);
